import React from "react"
import { Box, Flex } from "theme-ui"
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from "react-accessible-accordion"
import "assets/css/accordion.css"
import styled from "@emotion/styled"

const Wrapper = styled(Flex)`
    & .accordion__button {
        font-weight: bold;
        color: ${(props) => props.theme.colors.text1};
        border: 2px solid ${(props) => props.theme.colors.dark_grey};
        background-color: transparent;
        padding: 0.75rem;
        &:hover {
            color: ${(props) => props.theme.colors.secondary};
            border-color: ${(props) => props.theme.colors.dark_grey};
        }
    }
    & .accordion__panel,
    & .accordion__button[aria-expanded="true"] {
        background: #f8f8f8;
    }
    & .accordion__item {
        border-color: transparent;
    }
    & .accordion__panel p {
        font-weight: 400;
        color: #122f53;
    }
`

// markup
const IndexPage = ({ data }) => {
    return (
        <Wrapper>
            <Box className="accordion-box" sx={{ width: "100%" }}>
                <Accordion allowZeroExpanded>
                    {data.map((item, index) => (
                        <AccordionItem key={index}>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    {item.title}
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: item.content,
                                    }}
                                ></div>
                            </AccordionItemPanel>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Box>
        </Wrapper>
    )
}

export default IndexPage
